import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect } from 'react'
import Pagination from '../../layout/Pagination'
import { Table } from 'react-bootstrap'
import usePagination from '../../layout/usePagination'
import SearchInput from '../../layout/SearchInput'
import { getFormattedDate } from '../../helpers/utils'
import { buildPriceListApiUrl } from './helpers/priceListUrlHelpers'

const HistoryPriceList = ({ dbRef }) => {
  const [isFetching, setIsFetching] = useState(true)
  const [data, setData] = useState([])
  const [query, setQuery] = useState('')

  const {
    pagination,
    setPagination,
    handlePaginationClick
  } = usePagination({
    per_page: 25,
    current_page: 1,
    total_pages: 1
  })

  useEffect(() => {
    fetchDataFromServer()
  }, [pagination.current_page, query])

  const fetchDataFromServer = () => {
    setIsFetching(true)

    const params = new URLSearchParams({
      page: pagination.current_page,
      per_page: pagination.per_page,
      db_ref: dbRef
    })
    if (query) params.set('q', query)

    authFetch(`${buildPriceListApiUrl(BASE_BACKEND_URL, 'price_list_audits')}?${params.toString()}`, {
      method: 'GET',
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setData(data.table || [])
        setPagination((prev) => ({
          ...prev,
          total_pages: Math.ceil(data.count / prev.per_page)
        }))
      })
      .finally(() => setIsFetching(false))
  }

  return (
    <div>
      <div className="title-and-search-container">
        <h2></h2>
        <div className="search-input-container mb-20">

          <SearchInput
            query={query}
            placeholder="Buscar por código o nombre"
            onSearch={(value) => {
              setQuery(value)
              setPagination((prev) => ({ ...prev, current_page: 1 }))
            }}
            onClearSearch={() => {
              setQuery('')
              setPagination((prev) => ({ ...prev, current_page: 1 }))
            }}
          />

        </div>
      </div>

      <Table hover responsive>
        <thead className="table-header-gray">
          <tr>
            <th>FECHA Y HORA</th>
            <th>NOMBRE</th>
            <th>DESCRIPCIÓN</th>
          </tr>
        </thead>
        <tbody>
          {!isFetching && data.length > 0 ? (
            data.map((obj, index) => (
              <tr key={index}>
                <td>{getFormattedDate(obj.timestamp)}</td>
                <td>{obj.user_email}</td>
                <td>{obj.description}</td>
              </tr>
            ))
          ) : !isFetching ? (
            <tr>
              <td colSpan="3">No hay resultados</td>
            </tr>
          ) : (
            <tr>
              <td colSpan="3">Obteniendo datos...</td>
            </tr>
          )}
        </tbody>
      </Table>

      {pagination.total_pages > 1 && (
        <nav className="index-table" onClick={handlePaginationClick}>
          <Pagination
            current_page={pagination.current_page}
            total_pages={pagination.total_pages}
          />
        </nav>
      )}
    </div>
  )
}

export default HistoryPriceList
